import { createContext, useContext, useState, type ReactNode } from 'react';

interface PortalContextValue {
  renderComponent: (component: ReactNode) => void;
  clearComponent: () => void;
}

const PortalContext = createContext<PortalContextValue | undefined>(undefined);

export const usePortal = (): PortalContextValue => {
  const context = useContext(PortalContext);

  if (context === undefined) {
    throw new Error('usePortal must be used within a PortalProvider');
  }

  return context;
};

export const PortalProvider = ({ children }: { children: ReactNode }): JSX.Element => {
  const [component, setComponent] = useState<ReactNode>(null);

  const renderComponent = (newComponent: ReactNode): void => {
    setComponent(newComponent);
  };

  const clearComponent = (): void => {
    setComponent(null);
  };

  return (
    <PortalContext.Provider value={{ renderComponent, clearComponent }}>
      {children}
      <div id='portal-root'>{component}</div>
    </PortalContext.Provider>
  );
};
